import { ServiceFetch } from '../service-fetch'

export default class RedeemGiftRealListModel extends ServiceFetch {
    getRedeemGiftRealListBy = (data) => this.authFetch({
        url: 'redeem-gift-real-list/getRedeemGiftRealListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}
